export enum EmployeeOrderBy {
  VALORACIONES = "valoraciones",
  RANKING = "ranking"
}

